export default __webpack_public_path__ + "static/media/gift.9bdddf21.gif";